export default ({
  isSelf,
  status,
  status_video, // eslint-disable-line camelcase
}) => (status === 'active' || status === 'moh' || status_video === 'connected' || isSelf); // eslint-disable-line camelcase
